import { useState, FC } from "react";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import * as Styled from "./selector.styles";

interface Props {
  benefit: string;
  className?: string;
  idx: number;
  selecteditem?: number;
  selected?: string;
  handleSelector: (item: string) => void;
}

export const Selector: FC<Props> = ({
  benefit,
  className,
  idx,
  selecteditem,
  selected,
  handleSelector,
}) => {
  const { t } = useTranslation("global");

  return (
    <Styled.SelectorContainer
      onClick={() => handleSelector(benefit)}
      className={`${className} animate__delay-${idx}s`}
    >
      <Styled.SelectorBox>
        <img
          src={`/assets/benefits/selectorItems/${benefit}.svg`}
          alt={`selector-${benefit}`}
        />
        <h1 className="title-medium weight-medium">
          {t(`benefits.selectors.${benefit}.title`)}
        </h1>
        <Styled.PlusIcon>
          <AddIcon color="disabled" />
        </Styled.PlusIcon>
      </Styled.SelectorBox>

      <Styled.SelectorDescription
        selected={selected === benefit ? true : false}
        className="body-medium"
      >
        <p>{t(`benefits.selectors.${benefit}.description`)}</p>
      </Styled.SelectorDescription>
    </Styled.SelectorContainer>
  );
};
